import { z } from 'zod';
import type { ApiAuthMePatchBody, ApiAuthMeResponse } from '@/shared/types/api/auth';

// Owner spec (2026-05-30): address / postal code / PINFL are no longer profile
// fields — they're collected per-recipient (UserAddress) and per-parcel. The
// settings form keeps only the truly profile-level inputs (name, phone,
// languages).
export const profileFormSchema = z.object({
  first_name: z.string().trim().max(80, 'profile:errors.tooLong'),
  last_name: z.string().trim().max(80, 'profile:errors.tooLong'),
  phone_number: z.string().trim().max(40, 'profile:errors.tooLong'),
  languages: z.array(z.string().trim().min(1)),
});

export type ProfileFormValues = z.infer<typeof profileFormSchema>;

export const emptyProfileFormValues: ProfileFormValues = {
  first_name: '',
  last_name: '',
  phone_number: '',
  languages: [],
};

export const mapProfileToFormValues = (profile: ApiAuthMeResponse): ProfileFormValues => ({
  first_name: profile.first_name ?? '',
  last_name: profile.last_name ?? '',
  phone_number: profile.phone_number ?? '',
  languages: profile.languages ?? [],
});

export const mapFormValuesToPayload = (values: ProfileFormValues): ApiAuthMePatchBody => ({
  first_name: values.first_name,
  last_name: values.last_name,
  phone_number: values.phone_number,
  languages: values.languages,
});

export const AVATAR_MAX_BYTES = 5 * 1024 * 1024;
export const AVATAR_ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
